import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, TextInput } from '@guildeducationinc/recess';
import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import { v4 as uuid } from 'uuid';
export const ImportValueMappings = (props) => {
    const { t } = useLocale();
    const [draft, setDraft] = useState(Object.entries(props.importField.valueMappings).map(x => ({
        id: uuid(),
        source: x[0],
        target: x[1],
    })) ?? []);
    const handleAddMapping = () => {
        const newDraft = [...draft];
        newDraft.push({ id: uuid(), source: '', target: '' });
        setDraft(newDraft);
    };
    const handleDeleteMapping = (index) => {
        const newDraft = [...draft];
        newDraft.splice(index, 1);
        setDraft(newDraft);
    };
    const handleSaveMapping = () => {
        const valueMappings = {};
        for (const item of draft) {
            if (item.source && item.target) {
                valueMappings[item.source] = item.target;
            }
        }
        props.onSave({ ...props.importField, valueMappings });
    };
    const handleChange = (index, value) => {
        const newDraft = [...draft];
        newDraft[index] = value;
        setDraft(newDraft);
    };
    return (_jsxs("div", { className: props.className, children: [_jsx("div", { className: 'text-3xl', children: t('Value Mappings') }), _jsxs("table", { className: 'min-w-full divide-y divide-gray-900 border border-1 border-gray-900 mb-3', children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { className: 'p-3 text-lg text-left', children: t('Source Value') }), _jsx("th", { className: 'p-3 text-lg text-left', children: t('Maps To') }), _jsx("th", { className: 'p-3 text-lg text-left', children: t('Actions') })] }) }), _jsx("tbody", { className: 'divide-y divide-gray-900', children: draft.map((item, index) => (_jsxs("tr", { children: [_jsx("td", { className: 'px-2', children: _jsx(TextInput, { label: '', value: item.source, onChange: event => handleChange(index, {
                                            id: item.id,
                                            target: item.target,
                                            source: event.target.value,
                                        }) }) }), _jsx("td", { className: 'px-2', children: props.importField.field && props.importField.field.selections && (_jsx(Select, { className: 'pb-2', label: '', placeholder: t('Select Value'), options: props.importField.field.selections.map(s => ({
                                            value: s,
                                            label: t(`metadata.${props.importField.field?.entityType}.${props.importField.field?.code}.${s}`, { defaultMessage: s }),
                                        })), value: item.target, onChange: event => handleChange(index, {
                                            id: item.id,
                                            target: event.target.value ?? '',
                                            source: item.source,
                                        }) })) }), _jsx("td", { children: _jsx("div", { children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Delete', tag: `import_value_mapping_${item.id}`, label: 'Delete', appearance: 'minimal', icon: _jsx(DeleteOutlineIcon, { size: 20 }), onClick: () => handleDeleteMapping(index) }) }) })] }, item.id))) })] }), _jsxs("div", { className: 'flex gap-1', children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Add Mapping', tag: 'import_value_mappings', size: 'small', onClick: handleAddMapping, children: t('Add Mapping') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Save', tag: 'import_value_mappings', size: 'small', onClick: handleSaveMapping, children: t('Save') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Cancel', tag: 'import_value_mappings', size: 'small', variant: 'outlined', onClick: props.onCancel, children: t('Cancel') })] })] }));
};
